/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Source of the justification
 * @export
 */
export const JustificationSource = {
    Ai: 'ai',
    User: 'user',
    Template: 'template',
    Codebook: 'codebook'
} as const;
export type JustificationSource = typeof JustificationSource[keyof typeof JustificationSource];


export function instanceOfJustificationSource(value: any): boolean {
    for (const key in JustificationSource) {
        if (Object.prototype.hasOwnProperty.call(JustificationSource, key)) {
            if (JustificationSource[key as keyof typeof JustificationSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JustificationSourceFromJSON(json: any): JustificationSource {
    return JustificationSourceFromJSONTyped(json, false);
}

export function JustificationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): JustificationSource {
    return json as JustificationSource;
}

export function JustificationSourceToJSON(value?: JustificationSource | null): any {
    return value as any;
}

export function JustificationSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): JustificationSource {
    return value as JustificationSource;
}

